import { TRANSACTION_STORE_NAME } from 'Transactions/constants/store'
import { transactionFactory } from 'Transactions/redux/transactionStore'
import { Entity } from 'common/utils/Entity'

export const TransactionSchema = new Entity(
  TRANSACTION_STORE_NAME,
  {},
  { idAttribute: 'hash', afterStrategy: transactionFactory }
)
